var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("401")]),_c('h1',{domProps:{"textContent":_vm._s(_vm.$t('title'))}}),_c('p',{domProps:{"textContent":_vm._s(_vm.$t('text'))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }